/** Organization experimental feature: real factories (tasks, lines, factory apps). */
export const FEATURE_FACTORIES = "factories";

/** Organization experimental feature: Claude managed agents on the canvas. */
export const FEATURE_CLAUDE_MANAGED_AGENTS = "claude_managed_agents";

/** Organization experimental feature: SetupProvider wizard for GitHub and similar integrations. */
export const FEATURE_NEW_INTEGRATION_SETUP_FLOW = "new_integration_setup_flow";

/** Organization experimental feature: manual "Add intake" entry for Sentry in the Backlog column menu. */
export const FEATURE_FACTORY_SENTRY_INTAKE = "factory_sentry_intake";

/** Organization experimental feature: in-progress workspace Models settings page. */
export const FEATURE_WORKSPACE_MODELS = "workspace_models";

/** Organization experimental feature: model selector next to Start on a draft task. */
export const FEATURE_FACTORY_DRAFT_START_MODEL = "factory_draft_start_model";
